import { ILevelGeneralListDto } from "./level-general-list-dto";

export const levelGeneralListData = {
    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelGeneralListData = (typeof levelGeneralListData)[keyof typeof levelGeneralListData];

export interface ILevelGeneralListData extends ILevelGeneralListDto {
    [levelGeneralListData.guid]: string;
    [levelGeneralListData.deleted]: boolean;
    [levelGeneralListData.inactive]: boolean;
}

export class LevelGeneralListData
    implements ILevelGeneralListData, ILevelGeneralListDto
{
    [levelGeneralListData.guid]!: string;
    [levelGeneralListData.deleted]!: boolean;
    [levelGeneralListData.inactive]!: boolean;
}
